// -------------------------------
// Subcomponent: ViewerHeader
// Handles center/patient filtering and branding
// -------------------------------
export const ViewerHeader = () => {
    return (
        <header className="viewer-header">
            <div className="logo-title">
                <img
                    src="/neuronova_logo.png"
                    alt="Neuronova Logo"
                />
                <h1>
                    neuronova
                </h1>
            </div>
            <div className="header-links">
                <a href="https://doi.org/10.1093/brain/awab480" className="header-link">
                    <img src="/publication.svg" alt="Publication icon" />
                    Publication
                </a>
                <a href="https://github.com/penn-cnt/neuronova" target="_blank" rel="noopener noreferrer" className="header-link">
                    <img src="/github.svg" alt="GitHub icon" />
                    Source Code
                </a>
            </div>
        </header>
    );
};
